CustomTC.define('modules/presence/presence',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/load-data', 'modules/language', 'modules/chat/chat', 'text!modules/htmls/loading.html', 'css!modules/css/loading', 'css!modules/presence/css/presence'], function(util, core, config, constants, options, loadData, language, chat, loading) {
    return {
        //init
        init: function(playerUI, video) {
            this.playerUI = playerUI;
            this.initializePresence();
        },
        initializePresence: function() {
            var self = this;
            this.video = options.videoInfo[0];
        },
        usersViewing: function(data) {
            var livecount = data;
            // update live count
            var liveIcon = core.init('.' + constants.CSS_TOUCHCAST_LIVE_ICON + '');
            core.html(liveIcon, '<span class="tcLiveCount">' + livecount + '</span><span class="tcLiveIcon"></span>');
        }

    };
});
